import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06a3eb5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "googleLoginContainer" }
const _hoisted_2 = {
  ref: "signInButton",
  class: "googleSignIn"
}
const _hoisted_3 = { class: "otherButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn-primary ms-2",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.revoke && _ctx.revoke(...args)))
      }, " Revoke ")
    ])
  ]))
}